import { render } from "./MediaContext.vue?vue&type=template&id=ac715a10"
import script from "./MediaContext.vue?vue&type=script&lang=js"
export * from "./MediaContext.vue?vue&type=script&lang=js"

import exportComponent from "/Users/greg/sites/queens/wp-content/themes/queens/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/media-context/MediaContext.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac715a10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac715a10', __exports__)) {
    api.reload('ac715a10', __exports__)
  }
  
  module.hot.accept("./MediaContext.vue?vue&type=template&id=ac715a10", () => {
    api.rerender('ac715a10', render)
  })

}


export default __exports__